import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const InfoCircleIcon: FC<Props> = (props) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
      aria-label="info circle icon"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.756 15.693C12.756 16.107 12.42 16.443 12.006 16.443C11.592 16.443 11.256 16.107 11.256 15.693V11.394C11.256 10.98 11.592 10.644 12.006 10.644C12.42 10.644 12.756 10.98 12.756 11.394V15.693ZM11.25 8.291C11.25 7.877 11.586 7.541 12 7.541C12.414 7.541 12.75 7.877 12.75 8.291C12.75 8.705 12.414 9.073 12 9.073C11.586 9.073 11.25 8.768 11.25 8.354V8.291ZM12 2.5C6.762 2.5 2.5 6.761 2.5 12C2.5 17.238 6.762 21.5 12 21.5C17.238 21.5 21.5 17.238 21.5 12C21.5 6.761 17.238 2.5 12 2.5Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default InfoCircleIcon;
